import _ from "lodash";
import { TextInput } from "@toddle-edu/ds-web";
import React, { useState, useEffect } from "react";

const FieldInput = ({
  onEditValue,
  onClickOutside,
  initialValue,
  setOnBlur = false,
  testIdPrefix = "routine-templates",
  ...props
}) => {
  const [localValue, setLocalValue] = useState(initialValue);

  useEffect(() => {
    if (_.isEmpty(initialValue) || _.isNull(initialValue)) {
      setLocalValue("");
    } else {
      setLocalValue(initialValue);
    }
  }, [initialValue]);

  const onChangeValue = e =>
    setOnBlur ? setLocalValue(e.target.value) : onEditValue(e.target.value);

  const onBlurInput = () => {
    if (setOnBlur) {
      onEditValue(localValue);
    } else if (_.isFunction(onClickOutside)) {
      onClickOutside(localValue);
    }
  };

  setOnBlur
    ? () => onEditValue(localValue)
    : _.isFunction(onClickOutside)
    ? () => onClickOutside(localValue)
    : undefined;

  return (
    <div className="w-full" data-test-id={`${testIdPrefix}-fieldinput-wrapper`}>
      <TextInput
        {...props}
        testId={`${testIdPrefix}-fieldinput`}
        value={localValue}
        onChange={onChangeValue}
        onBlur={onBlurInput}
      />
    </div>
  );
};

export default FieldInput;
